var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content d-flex flex-column flex-column-fluid",attrs:{"id":"kt_content"}},[_c('Breadcrumb',{attrs:{"datas":_vm.breadcrumb_data}}),_c('div',{staticClass:"d-flex flex-column-fluid"},[_c('Create')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }